export const salesTypeKeyFactory = {
  all: [{ scope: 'sales-type' }] as const,
  list: () => [{ ...salesTypeKeyFactory.all[0], entity: 'list' }] as const,
}
